<template>
  <v-card flat>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left red--text">Качество КИ</th>
            <th class="text-left teal--text">Экономические последствия</th>
            <th class="text-left green--text">Доп. данные</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Рекомендаций к включению ЛП</td>
            <td class="font-weight-bold red--text">Если баллов >=18</td>
            <td class="teal--text">Если баллов >=6</td>
            <td class="green--text">Если баллов >= 4</td>
          </tr>
          <tr>
            <td>Рекомендаций к включению орфанного ЛП</td>
            <td class="font-weight-bold red--text">Если баллов >=12</td>
            <td class="teal--text">Если баллов >=2</td>
            <td class="green--text">Если баллов >=1</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: 'RecommendScore',
}
</script>

<style scoped></style>
